// src/components/place-card/place-card.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PlaceCardDetailsFragment on PlaceCardDetails {\n    id\n    title {\n      text\n    }\n    subtitle {\n      text\n    }\n    description {\n      text\n    }\n    media {\n      ... on Image {\n        description\n        url\n      }\n    }\n    footerText {\n      text\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  query PlaceCardDetailsQuery($context: ContextInput!, $placeId: String!, $directionsTo: DirectionsReferenceInput) {\n    placeCardDetails(context: $context, placeId: $placeId, directionsTo: $directionsTo) {\n      ...PlaceCardDetailsFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkHeading, UitkText } from "uitk-react-text";
// src/components/place-card/analytics/place-card-eg-clickstream-events.tsx
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var EVENT_CATEGORY = "maps";
var buildEvent = function(eventName, eventType, eventVersion) {
    return {
        event_name: eventName,
        event_type: eventType,
        event_version: eventVersion,
        event_category: EVENT_CATEGORY
    };
};
var IMPRESSION = "Impression";
var buildData = function(event, attributes) {
    return _objectSpreadProps(_objectSpread({}, attributes), {
        event: event
    });
};
function usePlaceCardClickstream() {
    var clickstreamTrack = useEgClickstream();
    var track = function(data) {
        if (clickstreamTrack) {
            clickstreamTrack(data);
        }
    };
    var trackMapCardPresented = function(id, type) {
        var event = buildEvent("map_card.presented", IMPRESSION, "1.0.0" /* ONE_ZERO_ZERO */ );
        var attributes = {
            content_card_list: [
                {
                    id: id,
                    card_type: type
                }
            ]
        };
        track(buildData(event, attributes));
    };
    return {
        trackMapCardPresented: trackMapCardPresented
    };
}
// src/components/place-card/place-card.tsx
var __fragment = gql(_templateObject());
var __Query = gql(_templateObject1(), __fragment);
var PlaceCardSize = /* @__PURE__ */ function(PlaceCardSize2) {
    PlaceCardSize2[PlaceCardSize2["STANDARD"] = 0] = "STANDARD";
    PlaceCardSize2[PlaceCardSize2["COMPACT"] = 1] = "COMPACT";
    return PlaceCardSize2;
}(PlaceCardSize || {});
var PlaceCard = function(props) {
    var _data_media, _data_media1, _data_subtitle, _data_description, _data_footerText;
    var inputs = props.inputs, skipSsr = props.skipSsr, fetchPolicy = props.fetchPolicy, propsData = props.data, size = props.size, imageRatio = props.imageRatio;
    var context = useBexApi().context;
    var variables = React.useMemo(function() {
        return _objectSpreadProps(_objectSpread({}, inputs), {
            context: context
        });
    }, [
        inputs,
        context
    ]);
    var _useQuery = useQuery(__Query, _objectSpread({
        variables: variables,
        ssr: !skipSsr,
        skip: !!propsData,
        notifyOnNetworkStatusChange: true
    }, fetchPolicy ? {
        fetchPolicy: fetchPolicy
    } : {})), currentData = _useQuery.data, loading = _useQuery.loading, error = _useQuery.error, previousData = _useQuery.previousData;
    var queryData = currentData !== null && currentData !== void 0 ? currentData : previousData;
    var data = propsData !== null && propsData !== void 0 ? propsData : queryData === null || queryData === void 0 ? void 0 : queryData.placeCardDetails;
    var ratio = imageRatio || size === 1 /* COMPACT */  ? UitkFigureAspectRatioType.R3_4 : UitkFigureAspectRatioType.R4_3;
    var placeCardMinWidth = size === 1 /* COMPACT */  ? 351 : 720;
    var placeCardMinHeight = 63;
    var trackMapCardPresented = usePlaceCardClickstream().trackMapCardPresented;
    React.useEffect(function() {
        if (data) {
            trackMapCardPresented(data === null || data === void 0 ? void 0 : data.id, "place" /* PLACE */ );
        }
    }, [
        data === null || data === void 0 ? void 0 : data.id
    ]);
    return data ? /* @__PURE__ */ React.createElement(UitkCard, null, /* @__PURE__ */ React.createElement("div", {
        "data-testid": "place-card-".concat(data.id)
    }), /* @__PURE__ */ React.createElement(UitkLayoutGrid, {
        alignItems: "start",
        columns: 4,
        style: {
            minHeight: placeCardMinHeight,
            minWidth: placeCardMinWidth
        }
    }, data.media ? /* @__PURE__ */ React.createElement(UitkLayoutGridItem, {
        colSpan: 1
    }, /* @__PURE__ */ React.createElement(UitkFigure, {
        ratio: ratio,
        roundcorner: [
            "startstart"
        ]
    }, "(", /* @__PURE__ */ React.createElement(UitkImage, {
        src: (_data_media = data.media) === null || _data_media === void 0 ? void 0 : _data_media.url,
        alt: (_data_media1 = data.media) === null || _data_media1 === void 0 ? void 0 : _data_media1.description,
        placeholderImage: true
    }))) : null, /* @__PURE__ */ React.createElement(UitkLayoutGridItem, {
        colSpan: 3
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkCardContentSection, null, /* @__PURE__ */ React.createElement(UitkHeading, null, data.title.text), data.subtitle ? /* @__PURE__ */ React.createElement(UitkText, {
        size: 200,
        spacing: "one"
    }, (_data_subtitle = data.subtitle) === null || _data_subtitle === void 0 ? void 0 : _data_subtitle.text) : null, data.description ? /* @__PURE__ */ React.createElement(UitkText, {
        size: 200,
        spacing: "one"
    }, (_data_description = data.description) === null || _data_description === void 0 ? void 0 : _data_description.text) : null)), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkCardContentSection, null, data.footerText ? /* @__PURE__ */ React.createElement(UitkText, {
        size: 200
    }, (_data_footerText = data.footerText) === null || _data_footerText === void 0 ? void 0 : _data_footerText.text) : null)))))) : null;
};
PlaceCard.displayName = "PlaceCard";
// src/components/place-card/floating-place-card.tsx
import React2 from "react";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
var FloatingPlaceCard = function(props) {
    var placeId = props.placeId, size = props.size;
    var maxWidth = size === 1 /* COMPACT */  ? 351 : 720;
    return /* @__PURE__ */ React2.createElement(UitkLayoutPosition, {
        type: "absolute",
        tag: "div",
        position: {
            bottom: "one"
        },
        pointerEvents: "none",
        style: {
            width: "100%"
        }
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlex2, {
        justifyContent: "center"
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem2, {
        grow: 1,
        maxWidth: maxWidth
    }, /* @__PURE__ */ React2.createElement("div", {
        style: {
            pointerEvents: "all"
        }
    }, /* @__PURE__ */ React2.createElement(PlaceCard, _objectSpreadProps(_objectSpread({}, props), {
        inputs: {
            placeId: placeId
        }
    }))))));
};
export { FloatingPlaceCard, PlaceCard, __fragment as PlaceCardFragment, PlaceCardSize };
//# sourceMappingURL=index.js.map